import React from 'react';
import {Link} from 'react-router';
import AdminTitle from '../../components/AdminTitle';
import LiveSearch from '../../components/LiveSearch';
import Api, { Utils } from '../../Api';
import FontAwesome from 'react-fontawesome';
import Button from '../../components/Button';

export default class Retailer extends React.Component {
  constructor() {
    super();

    this.state = {
      retailers: [],
      search: '',
      waitingSearch: false,
      searchResults: []
    };

    Utils.bindThis(this,
      [
        'onSearchChange',
        'getRetailerLink',
        'retailerList',
        'executeSearch',
        'impersonateRetailerOwner'
      ]);
  }

  executeSearch() {
    if (this.state.search.length === 0) return;

    Api.getRetailers(this.state.search).then(
      response => {
        this.setState({
          waitingSearch: false,
          searchResults: response
        });
      }
    );

    this.setState({waitingSearch: true});
  }

  impersonateRetailerOwner(userToken) {
    console.log(`Impersonating user token: ${userToken}`);

    return Api.impersonateUserByToken(userToken).then(
      () => {
        this.context.router.push('/')
      },
      (error) => {
        console.log("Error impersonating user: " + error.response.message);
      }
    );
  }

  onSearchChange(value) {
    let payload = {};
    payload.search = value.trim();
    if (payload.search.length === 0) payload.searchResults = [];

    this.setState(payload);
  }

  componentDidMount() {
    Api.getRetailers().then(
      response => {
        this.setState({
          retailers: response
        });
      }
    )
  }

  getRetailerLink(retailer) {
    let link = `/admin/retailers/${retailer.token}`;
    let buttons = [];

    buttons.push(
      <Button
        key={`${retailer.token}-marketplace-button`}
        to={`/retailer/${retailer.token}`}>
        Marketplace
      </Button>
    );

    if (retailer.owner_user_token) {
      buttons.push(
        <Button
          key={`${retailer.token}-impersonate-button`}
          className="retailer-list-item-impersonate-button"
          onClick={() => this.impersonateRetailerOwner(retailer.owner_user_token)}>
          Impersonate
        </Button>
      );
    }

    return (
      <span key={retailer.token}>
        <div className="retailer-list-item">
          <Link className="retailer-list-item-description" key={`${retailer.token}-description`}
                style={{cursor: 'pointer'}} to={link}>
            <h4>{retailer.name}</h4>
            <p>{retailer.description}</p>
          </Link>
          {buttons}
        </div>
      </span>
    );
  }

  retailerList() {
    let ret = [];

    if (this.state.search.length > 0) {
      if (this.state.searchResults.length === 0 && this.state.waitingSearch) {
        return <div className="page-loading"><FontAwesome name="circle-o-notch" spin/></div>;
      } else if (this.state.searchResults.length === 0) {
        return <div>I can't find anything.</div>;
      }

      ret = this.state.searchResults.map((retailer) => {
        return this.getRetailerLink(retailer);
      });
    } else {
      ret = this.state.retailers.map((retailer) => {
        return this.getRetailerLink(retailer);
      });
    }

    if (ret.length === 0) {
      return <div className="page-loading"><FontAwesome name="circle-o-notch" spin/></div>;
    }

    return ret;
  }

  componentDidUpdate(prevProps, prevState) {
    // Updates the product list and search results based on changes to the search and activeOnly states.
    if (this.state.activeOnly !== prevState.activeOnly || this.state.search.trim() !== prevState.search.trim()) {
      if (this.state.search.trim().length > 0) this.executeSearch();
    }
  }

  render() {
    return (
      <div>
        <AdminTitle title="Retailer List">
          <Link to="/admin/retailer/create" className="button button--small">New Retailer</Link>
        </AdminTitle>
        <LiveSearch onChange={this.onSearchChange} waitingSearch={this.state.waitingSearch}
                    placeholder="Search Retailers"/>
        {this.retailerList()}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/Retailer.js
 **/